<!-- The red car on the grid at night, five rivals ahead, the skyline behind.
     Drawn, not photographed, so it is crisp at every size and costs nothing. -->
<template>
  <svg class="grid-scene" viewBox="0 0 360 220" role="img" :aria-label="label">
    <defs>
      <linearGradient :id="sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#050817" />
        <stop offset="1" stop-color="#1d2752" />
      </linearGradient>
      <linearGradient :id="road" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#2a2c33" />
        <stop offset="1" stop-color="#43454d" />
      </linearGradient>
    </defs>
    <rect width="360" height="220" :fill="`url(#${sky})`" />
    <!-- skyline -->
    <g fill="#111a3d">
      <rect x="0" y="70" width="26" height="40" /><rect x="28" y="58" width="20" height="52" />
      <rect x="52" y="76" width="30" height="34" /><rect x="250" y="62" width="22" height="48" />
      <rect x="276" y="74" width="34" height="36" /><rect x="314" y="54" width="20" height="56" />
      <rect x="338" y="72" width="22" height="38" />
    </g>
    <g fill="#18224a">
      <path d="M118 110 L121 48 L134 48 L132 110Z" /><path d="M140 110 L143 48 L156 48 L154 110Z" />
      <path d="M162 110 L165 48 L178 48 L176 110Z" />
    </g>
    <rect x="112" y="42" width="74" height="6" fill="#22306a" />
    <rect x="112" y="47" width="74" height="1.5" fill="#78c8ff" opacity=".8" />
    <g stroke="#a0dcff" stroke-opacity=".7" fill="none">
      <circle cx="222" cy="72" r="26" stroke-width="1.6" />
      <path d="M222 46V98M196 72H248M204 54L240 90M240 54L204 90" stroke-width=".7" />
    </g>
    <path d="M222 72 L210 110 M222 72 L234 110" stroke="#18224a" stroke-width="3" />
    <!-- floodlights -->
    <g fill="#fff6cf">
      <rect x="16" y="30" width="16" height="5" /><rect x="328" y="30" width="16" height="5" />
    </g>
    <rect x="23" y="35" width="2" height="75" fill="#5b6170" />
    <rect x="335" y="35" width="2" height="75" fill="#5b6170" />
    <!-- track -->
    <path d="M150 110 L210 110 L360 220 L0 220Z" :fill="`url(#${road})`" />
    <path d="M150 110 L142 110 L-20 220 L0 220Z" fill="#d8262b" />
    <path d="M210 110 L218 110 L380 220 L360 220Z" fill="#d8262b" />
    <path d="M150 110 L210 110 L213 113 L147 113Z" fill="#fafafa" opacity=".9" />
    <!-- rivals on the grid ahead -->
    <g v-for="(c, i) in rivals" :key="i" :transform="`translate(${c.x} ${c.y}) scale(${c.s})`">
      <rect x="-14" y="-9" width="28" height="9" rx="2" :fill="c.colour" />
      <rect x="-15" y="-12" width="30" height="2.4" fill="#16181d" />
      <rect x="-12" y="-6" width="5" height="2" fill="#ff2a2a" /><rect x="7" y="-6" width="5" height="2" fill="#ff2a2a" />
      <rect x="-15" y="-4" width="5" height="5" fill="#111" /><rect x="10" y="-4" width="5" height="5" fill="#111" />
    </g>
    <!-- the player's car, front and centre -->
    <g transform="translate(212 200)">
      <ellipse cx="0" cy="6" rx="66" ry="7" fill="#000" opacity=".35" />
      <rect x="-64" y="-18" width="22" height="22" rx="3" fill="#111" />
      <rect x="42" y="-18" width="22" height="22" rx="3" fill="#111" />
      <path d="M-60 -6 L-54 -34 L-30 -48 L30 -48 L54 -34 L60 -6Z" fill="#d0141c" />
      <path d="M-28 -44 L28 -44 L22 -32 L-22 -32Z" fill="#0b0d12" />
      <rect x="-52" y="-24" width="20" height="5" rx="1" fill="#ff3b30" />
      <rect x="32" y="-24" width="20" height="5" rx="1" fill="#ff3b30" />
      <rect x="-62" y="-58" width="124" height="6" fill="#16181d" />
      <rect x="-40" y="-52" width="4" height="8" fill="#16181d" /><rect x="36" y="-52" width="4" height="8" fill="#16181d" />
      <rect x="-14" y="-16" width="28" height="9" rx="1" fill="#f3f3f3" />
      <text x="0" y="-9" text-anchor="middle" font-size="8" font-weight="800" fill="#111">1</text>
    </g>
  </svg>
</template>

<script setup>
import { useId } from 'vue';

// Ids are per instance: Ionic keeps the previous page in the DOM, and a
// gradient id shared with a hidden page paints nothing.
const uid = useId();
const sky = `gs-sky-${uid}`;
const road = `gs-road-${uid}`;
defineProps({ label: { type: String, default: 'The red supercar on the grid at night, five rivals ahead' } });
const rivals = [
  { x: 170, y: 118, s: 0.34, colour: '#1f6feb' },
  { x: 190, y: 124, s: 0.42, colour: '#f2c200' },
  { x: 160, y: 132, s: 0.52, colour: '#2e9d4f' },
  { x: 205, y: 142, s: 0.64, colour: '#f0f0f0' },
  { x: 148, y: 158, s: 0.8, colour: '#7a3fd0' },
];
</script>

<style scoped>
.grid-scene { display: block; width: 100%; height: auto; border-radius: var(--radius); }
</style>
